import { createSlice } from "@reduxjs/toolkit";
import dayjs from "dayjs";
import { factory } from "../../api/apiFactory";
import extandDayjs from "../../helpers/dayjs";
import { showNotification } from "./notificationSlice";
const leaveApi = factory.get("leave");

const initialState = {
  leave: {
    loading: false,
    dialog: false,
    form: {
      id: "",
      user_id: null,
      leave_category: {},
      history: [],
      start_date: dayjs().format("YYYY-MM-DD HH:00:00"),
      days: "1",
      reason: "",
      day_alternative_date: dayjs().format("YYYY-MM-DD"),
      alternative_user: null,
      minutes: 60,
      ticket_no: "",
      attachments: [],
      temp_attachments: [],
    },
  },
  leaves: {
    loading: false,
    data: [],
    total: 0,
    filters: {
      skip: 0,
      take: 100,
      user_id: "",
      department_id: "",
      date: extandDayjs().format("YYYY-MM-DD"),
      start_date: extandDayjs().format("YYYY-MM-DD"),
      end_date: extandDayjs().format("YYYY-MM-DD"),
      date_type: "month",
      is_me: "true",
      leave_status_id: 0,
      leave_category_id: 0,
      page: 0,
    },
  },
  leave_category: {
    loading: false,
    data: [],
  },
};

export const leaveSlice = createSlice({
  name: "leave",
  initialState,
  reducers: {
    setDialog: (state, action) => {
      state.leave.dialog = !state.leave.dialog;
      state.leave.form.id = action.payload ? action.payload : "";
    },
    setDataTable: (state, { payload }) => {
      state.leaves.data = payload.data.data;
      state.leaves.total = payload.data.total;
    },
    setCategory: (state, { payload }) => {
      state.leave_category.data = payload.data.data;
    },
    setById: (state, { payload }) => {
      state.leave.form = {
        ...state.leave.form,
        ...payload,
      };
    },
    setLoading: (state, action) => {
      state[action.payload].loading = !state[action.payload].loading;
    },
    resetForm: (state, action) => {
      state.leave.form = initialState.leave.form;
    },
    setFilters: (state, { payload }) => {
      state.leaves.filters = {
        ...state.leaves.filters,
        ...payload,
      };
    },
    resetFilters: (state) => {
      state.leaves.filters = initialState.leaves.filters;
    },
  },
});

export const {
  setLoading,
  setDialog,
  setDataTable,
  setById,
  resetForm,
  setCategory,
  setFilters,
  resetFilters,
} = leaveSlice.actions;

export default leaveSlice.reducer;

//axios
const getAll = () => async (dispatch, getState) => {
  try {
    //getState is the state of the store print it to see what you have

    const filters = getState().leave.leaves.filters;

    const filters_params = {
      ...filters,
      start_date: filters.date_type === "month" ? null : filters.start_date,
      end_date: filters.date_type === "month" ? null : filters.end_date,
      date: filters.date_type === "month" ? filters.date : null,
    };

    dispatch(setLoading("leaves"));
    const res = await leaveApi.getAll(filters_params);
    dispatch(setDataTable(res));
    dispatch(setLoading("leaves"));
  } catch (err) {
    dispatch(setLoading("leaves"));
    throw new Error(err);
  }
};
const getCategories = (params) => async (dispatch) => {
  try {
    dispatch(setLoading("leave_category"));
    const res = await leaveApi.category(params);
    dispatch(setCategory(res));
    dispatch(setLoading("leave_category"));
  } catch (err) {
    dispatch(setLoading("leave_category"));
    throw new Error(err);
  }
};
const changeLeaveStatus = (data) => async (dispatch, getState) => {
  try {
    await leaveApi.changeLeaveStatus(data);
    dispatch(getAll());
    dispatch(
      showNotification({
        message: "تم تغيير الحالة بنجاح",
        type: "success",
      })
    );
  } catch (err) {
    //set notification error
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const changeLeaveStatusChecked = (data) => async (dispatch, getState) => {
  try {
    var res = await leaveApi.changeLeaveStatusForChecked({ leaves: data });
    dispatch(getAll());
    dispatch(
      showNotification({
        message: res.data.message,
        type: "success",
      })
    );
    return true;
  } catch (err) {
    //set notification error
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const deleteById = (id, role_name) => async (dispatch) => {
  try {
    if (role_name === "super-admin") {
      await leaveApi.deleteForAdmin(id);
    } else {
      await leaveApi.deleteForAll(id);
    }
    dispatch(
      showNotification({
        message: "تم الحذف بنجاح",
        type: "success",
      })
    );
    dispatch(getAll());
  } catch (err) {
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const getById = (id) => async (dispatch) => {
  try {
    dispatch(setLoading("leave"));
    const res = await leaveApi.getById(id);
    dispatch(setById(res.data.data[0]));
    dispatch(setLoading("leave"));
  } catch (err) {
    dispatch(setLoading("leave"));
    throw new Error(err);
  }
};
const create = (data) => async (dispatch, getState) => {
  try {
    dispatch(setLoading("leave"));
    const leave_category_id = getState().leave.leave_category.data[0].id;
    let formData = new FormData();

    formData.append("user_id", data.user_id ? data.user_id.id : "");
    formData.append(
      "leave_category_id",
      data.leave_category.id ? data.leave_category.id : leave_category_id
    );
    formData.append(
      "start_date",
      dayjs(data.start_date).format("YYYY-MM-DD HH:00")
    );
    formData.append("days", data.days);
    formData.append("reason", data.reason);
    formData.append("ticket_no", data.ticket_no || "");

    // if (data.leave_category.key === "day_alternative_leave") {
    //   let text = "";
    //   text += "- اسم البديل :" + data.alternative_user.full_name + " \n";
    //   text +=
    //     "- تاريخ البديل :" +
    //     dayjs(data.day_alternative_date).format("YYYY-MM-DD") +
    //     " ";
    //   formData.append("reason", text);
    // } else {
    //   formData.append("reason", data.reason);
    // }
    formData.append("minutes", data.minutes);

    if (data.temp_attachments.length > 0) {
      data.temp_attachments.forEach((item, index) => {
        formData.append(`attachments[${index}]`, item);
      });
    }
    // case "temp_attachments":
    //     data[key].forEach((item, index) => {
    //         formData.append(`attachments[${index}]`, item);
    //     });
    //     break;

    // loop  formData
    // for (var key of formData.entries()) {
    //   console.log(key[0] + ", " + key[1]);
    // }

    await leaveApi.create(formData);

    dispatch(setLoading("leave"));
    dispatch(setDialog());
    dispatch(
      showNotification({
        message: "تم  انشاء الاجازة بنجاح",
        type: "success",
      })
    );
    dispatch(getAll());
  } catch (err) {
    dispatch(setLoading("leave"));
    dispatch(
      showNotification({
        message: err.response.data.errors,
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const update = (data) => async (dispatch) => {
  try {
    dispatch(setLoading("announcement"));
    data.receivers = data.receivers.map((item) => {
      return item.id;
    });
    data.is_all = data.is_all == "false" ? false : true;
    await leaveApi.create(data);
    dispatch(setDialog());
    dispatch(getAll());
    dispatch(setLoading("announcement"));
  } catch (err) {
    dispatch(setLoading("announcement"));
    throw new Error(err);
  }
};

export const Leave = {
  getAll,
  changeLeaveStatus,
  changeLeaveStatusChecked,
  getCategories,
  deleteById,
  getById,
  create,
  update,
};
